import { DESTINATION_TYPES } from '../../../destination/constants/destinationTypes';
import { EntityTileProps } from '../../../../layout/interfaces/tile';

export default function DestinationTilesFactory(destinations: any[], isCopyMode?: boolean): Array<EntityTileProps> {
  return destinations.map((destination, index) => ({
    id: destination.id.toString(),
    sortOrder: index,
    thumbnail: destination.dest_type_logo_url,
    darkModeThumbnail: destination.dest_type_dark_mode_logo_url,
    title: destination.name,
    data: { ...destination, is_copy_mode: isCopyMode },
    errored: !!destination.error,
    errorReason: destination.error,
    metaData: {
      ...DESTINATION_TYPES[destination.dest_type] as any,
      isCopyMode
    }
  }));
}
